<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="!forceUpdate"
    :close-on-press-escape="!forceUpdate"
    :show-close="!forceUpdate"
    width="420px"
    custom-class="version-update-dialog"
  >
    <div class="version-update-content">
      <div class="update-icon">
        <i class="el-icon-download"></i>
      </div>
      <h2 class="update-title">发现新版本</h2>
      <div class="version-info">
        <span class="current-version">v{{ currentVersion }}</span>
        <i class="el-icon-right"></i>
        <span class="new-version">v{{ latestVersion }}</span>
      </div>
      <div class="update-description" v-if="description">
        <h3>更新内容：</h3>
        <p>{{ description }}</p>
      </div>
      <div class="force-update-tip" v-if="forceUpdate">
        <i class="el-icon-warning"></i>
        此版本为重要更新，请立即下载安装
      </div>
      <div class="update-actions">
        <el-button
          v-if="!forceUpdate"
          @click="handleCancel"
          size="medium"
        >
          稍后再说
        </el-button>
        <el-button
          type="primary"
          @click="handleUpdate"
          size="medium"
          :loading="downloading"
        >
          {{ downloading ? '下载中...' : '立即更新' }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VersionUpdateDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentVersion: {
      type: [String, Number],
      required: true
    },
    latestVersion: {
      type: [String, Number],
      required: true
    },
    downloadUrl: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    forceUpdate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      downloading: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleUpdate() {
      this.downloading = true
      // 在 Capacitor 环境中使用浏览器打开下载链接
      if (window.Capacitor) {
        window.open(this.downloadUrl, '_blank')
      } else {
        // 网页环境
        window.location.href = this.downloadUrl
      }
      setTimeout(() => {
        this.downloading = false
        this.$emit('update')
      }, 2000)
    },
    handleCancel() {
      this.dialogVisible = false
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.version-update-content {
  text-align: center;
  padding: 10px 0;

  .update-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 20px;
    background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 40px;
      color: #fff;
    }
  }

  .update-title {
    font-size: 20px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 16px;
  }

  .version-info {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-bottom: 20px;
    font-size: 14px;

    .current-version {
      color: var(--text-secondary);
      padding: 4px 12px;
      background: var(--bg-light);
      border-radius: 4px;
    }

    i {
      color: var(--primary);
      font-size: 16px;
    }

    .new-version {
      color: var(--primary);
      font-weight: 600;
      padding: 4px 12px;
      background: rgba(52, 152, 219, 0.1);
      border-radius: 4px;
    }
  }

  .update-description {
    text-align: left;
    background: var(--bg-light);
    padding: 16px;
    border-radius: 8px;
    margin-bottom: 20px;

    h3 {
      font-size: 14px;
      color: var(--text-secondary);
      margin-bottom: 8px;
      font-weight: 500;
    }

    p {
      font-size: 14px;
      color: var(--text-primary);
      line-height: 1.6;
      white-space: pre-wrap;
    }
  }

  .force-update-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: var(--warning);
    font-size: 13px;
    margin-bottom: 20px;
    padding: 10px;
    background: rgba(243, 156, 18, 0.1);
    border-radius: 6px;

    i {
      font-size: 16px;
    }
  }

  .update-actions {
    display: flex;
    gap: 12px;
    justify-content: center;

    .el-button {
      min-width: 120px;
    }
  }
}
</style>
